module.exports = __webpack_public_path__ + "img/fish.4f7cfeef.svg";